import { isShuttleVehicle } from "features/CenterContent/VehicleDetails/AlternativeTransportDetails/utils";
import { VehicleSummary } from "features/CenterContent/VehicleDetails/shared/VehicleSummary";
import { removeStationFromStopName } from "features/VehicleSidebar/VehicleList/utils/stopNameUtils";
import { FC } from "react";
import { AlternativeTransportVehicle } from "shared/types/alternativeTransport";

type Props = {
  alternativeTransport: AlternativeTransportVehicle;
};

export const Itinerary: FC<Props> = ({ alternativeTransport }) => {
  const {
    lineNames,
    tripPatternId,
    trainIds,
    itinerary,
    type,
    driverPhoneNumber,
    hastusShuttlePlanId,
    originStopName,
    destinationStopName,
    firstStopName,
    scheduledDepartureTimeOrigin,
    scheduledArrivalTimeDestination,

    operatorName,
  } = alternativeTransport;

  const isShuttle = isShuttleVehicle(alternativeTransport);
  const returnStops = itinerary?.returnStops ?? [];

  const turnaroundStopName =
    returnStops.length > 0 ? returnStops[returnStops.length - 1].name : null;

  const replacesTrainIds = trainIds.length > 0 ? trainIds.join(", ") : null;

  const tripDetails = [hastusShuttlePlanId || tripPatternId]
    .filter((stop): stop is string => stop !== null && stop !== "")
    .join(" / ");

  const stations = [
    removeStationFromStopName(originStopName),
    removeStationFromStopName(destinationStopName),
    turnaroundStopName,
  ]
    .filter((stop): stop is string => stop !== null && stop !== "")
    .join("–");

  return (
    <VehicleSummary
      type={type}
      stations={stations.concat(
        isShuttle && firstStopName && firstStopName !== originStopName
          ? ` (oppstart ${firstStopName})`
          : "",
      )}
      trains={replacesTrainIds}
      tripDetails={tripDetails}
      driverPhoneNumber={driverPhoneNumber}
      lineNames={lineNames.map((line) => line).join(", ")}
      operatorName={operatorName}
      startTime={scheduledDepartureTimeOrigin}
      endTime={scheduledArrivalTimeDestination}
    />
  );
};
